import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Service from "./pages/Service";
import Products from "./pages/Products";
import Sportswear from "./pages/ProductCategories/Sportswear";
import CasesBags from "./pages/ProductCategories/CasesBags";
import PointOfSale from "./pages/ProductCategories/PointOfSale";
import ScrollToTop from "./ScrollToTop";

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/service_process" element={<Service />} />

          {/* Product Categories Routes */}
          <Route path="/product_categories" element={<Products />} />
          <Route path="/product_categories/sportswear" element={<Sportswear />} />
          <Route path="/product_categories/point-of-sale" element={<PointOfSale />} />
          <Route path="/product_categories/cases-bags" element={<CasesBags />} />
          {/* Add other product-specific routes here */}
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;
